// product-patch.js
// Patches VariantSelects prototype to fix:
//   1. connectedCallback: initialize Add to Bag button state on page load
//   2. updateMedia: support overrideMediaId for color-swatch image switching
//   3. renderProductInfo: immediate price update + NaN-safe #fp calculation
//   4. updateOptions: pad the missing "Complimentary Engraving" option so
//      variant matching doesn't falsely mark engraving-enabled products sold out
(function () {
  function initButtonState(el) {
    if (!el.currentVariant) {
      if (typeof el.toggleAddButton === 'function') el.toggleAddButton(true, '', true);
      if (typeof el.setUnavailable === 'function') el.setUnavailable();
    } else {
      if (typeof el.toggleAddButton === 'function') {
        el.toggleAddButton(!el.currentVariant.available, el.currentVariant.available ? '' : (window.theme && window.theme.variantStrings ? window.theme.variantStrings.soldOut : 'Sold out'), false);
      }
    }
  }

  function patch(p) {
    // Fix 0: connectedCallback — initialize button state after variant is resolved
    var origConnected = p.connectedCallback;
    p.connectedCallback = function () {
      origConnected.call(this);
      initButtonState(this);
    };

    // Fix 1: updateMedia with overrideMediaId support for color swatch image switching
    p.updateMedia = function (overrideMediaId) {
      if (!this.currentVariant) return;
      var slider = document.getElementById('MediaGallery-' + this.dataset.section);
      if (!slider) return;
      var mediaId;
      if (overrideMediaId) {
        mediaId = overrideMediaId;
      } else if (this.currentVariant.featured_media) {
        mediaId = this.dataset.section + '-' + this.currentVariant.featured_media.id;
      } else {
        return;
      }
      var active = slider.querySelector('[data-media-id="' + mediaId + '"]');
      if (!active) return;
      slider.querySelectorAll('[data-media-id]').forEach(function (el) { el.classList.remove('is-active'); });
      active.classList.add('is-active');
      if (this.featured) return;
      active.parentElement.prepend(active);
      window.setTimeout(function () {
        active.parentElement.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      });
    };

    // Fix 2: renderProductInfo with immediate price update + NaN-safe #fp calculation
    p.renderProductInfo = function () {
      var self = this;
      var sections = this.getSectionsToRender();

      if (this.currentVariant && this.currentVariant.price) {
        var priceEl = document.getElementById('price-' + this.dataset.section);
        if (priceEl) {
          var money = priceEl.querySelector('span.price span.money, span.price span.amount');
          if (money) {
            var dollars = this.currentVariant.price / 100;
            var fmt = '$' + (Number.isInteger(dollars)
              ? dollars.toLocaleString('en-US')
              : dollars.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
            money.textContent = fmt;
            var btn = document.querySelector('button#AddToCart>span.money');
            if (btn) btn.textContent = fmt;
            if (document.querySelector('#fp')) {
              document.querySelectorAll('#fp p[mult]').forEach(function (prc) {
                prc.innerHTML = '$' + Math.round(dollars * (parseFloat(prc.getAttribute('mult')) || 1)).toLocaleString('en-US');
              });
            }
          }
        }
      }

      fetch(this.dataset.url + '?variant=' + this.currentVariant.id + '&section_id=' + this.dataset.section)
        .then(function (r) { return r.text(); })
        .then(function (responseText) {
          var html = new DOMParser().parseFromString(responseText, 'text/html');
          sections.forEach(function (id) {
            var dest = document.getElementById(id);
            var src = html.getElementById(id);
            if (src && dest) dest.innerHTML = src.innerHTML;
            var price = document.getElementById(id);
            var sticky = document.getElementById(id + '--sticky');
            if (price) {
              price.classList.remove('visibility-hidden');
              var el = price.querySelector('span.price span.money') || price.querySelector('span.price span.amount');
              if (el) {
                var raw = parseFloat((el.textContent || el.innerText || '').replace(/[^0-9.]/g, '')) || 0;
                var sym = (el.textContent || el.innerText || '').trim().charAt(0);
                var addBtn = document.querySelector('button#AddToCart>span.money');
                if (addBtn) addBtn.innerHTML = sym + Math.round(raw).toLocaleString('en-US');
                if (document.querySelector('#fp')) {
                  document.querySelectorAll('#fp p[mult]').forEach(function (prc) {
                    prc.innerHTML = sym + Math.round(raw * (parseFloat(prc.getAttribute('mult')) || 1)).toLocaleString('en-US');
                  });
                }
              }
            }
            if (sticky) sticky.classList.remove('visibility-hidden');
          });
          self.toggleAddButton(!self.currentVariant.available, window.theme.variantStrings.soldOut);
        });
    };

    // Fix 3: updateOptions — pad the missing "Complimentary Engraving" option.
    // On products where engraving is offered via the separate engraving
    // checkbox (assets/engraving-checkbox.js) instead of its own variant
    // fieldset, this.options ends up one entry shorter than variant.options.
    // updateMasterId() does strict positional matching, so it never finds a
    // match, this.currentVariant stays undefined, and setUnavailable() then
    // force-marks the product sold out and hides the price — even when the
    // underlying "No Engraving" variant is actually in stock. The "Add
    // Engraving" variants are intentionally kept at zero inventory (engraving
    // itself is captured via line item properties, not variant selection), so
    // we always resolve the missing slot to "No Engraving".
    var origUpdateOptions = p.updateOptions;
    p.updateOptions = function () {
      origUpdateOptions.call(this);
      var variants = this.getVariantData();
      var fullLength = (variants && variants.length) ? variants[0].options.length : this.options.length;
      if (this.options.length === fullLength - 1) {
        this.options.push('No Engraving');
      }
    };
  }

  function tryPatch() {
    var ctor = customElements.get('variant-selects');
    if (ctor) {
      patch(ctor.prototype);
      // Fix already-connected instances (connectedCallback already fired before this patch ran)
      document.querySelectorAll('variant-selects').forEach(function (el) {
        el.updateOptions();
        el.updateMasterId();
        initButtonState(el);
      });
    } else {
      setTimeout(tryPatch, 80);
    }
  }
  tryPatch();
})();
